import { SingleItemRequirement } from "../requirements/SingleItemRequirement";
import { ComponentTemplate } from "./ComponentTemplate";
import { DataFieldTemplate } from "./DataFieldTemplate";

export class EntryGroupTemplate extends ComponentTemplate {
	public static readonly $type: string = "EntryGroupTemplate";
	public readonly $type: string = EntryGroupTemplate.$type;

	public isReusable!: boolean;
	public requirements!: Array<SingleItemRequirement<DataFieldTemplate>>;
}
